import classNames from 'classnames'
import React, { useMemo } from 'react'

type Props = {
  step: number
}

export default function CampaignProgressBar({ step }: Props): JSX.Element {
  const stepsList = useMemo(
    () => [
      { step: 1, name: 'Campaign Type' },
      { step: 2, name: 'Product' },
      { step: 3, name: 'Objective' },
      { step: 4, name: 'Details' },
      { step: 5, name: 'Review' },
    ],
    [],
  )
  return (
    <div className="flex flex-row">
      {stepsList.map((s, key) => (
        <div key={key} className="flex flex-col w-[82px]">
          <div className="flex flex-row items-center justify-center">
            <div
              className={classNames('flex flex-1 h-[1px]', {
                'bg-primary-persian-blue': s.step <= step && s.step > 1,
                'bg-gainsboro-gray': s.step > step,
              })}
            />
            <div
              className={classNames('rounded-full h-4 w-4', {
                'border-2 border-primary-persian-blue': step === s.step,
                'bg-gainsboro-gray': step < s.step,
                'bg-primary-persian-blue': step > s.step,
              })}
            />
            <div
              className={classNames('flex flex-1 h-[1px]', {
                'bg-primary-persian-blue': s.step < step,
                'bg-gainsboro-gray': s.step < stepsList.length,
              })}
            />
          </div>
          <span className="text-[10px] font-semibold text-center">{s.name}</span>
        </div>
      ))}
    </div>
  )
}
